/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrganizationUserDto
 */
export interface UpdateOrganizationUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationUserDto
     */
    lastName?: string | null;
}

/**
 * Check if a given object implements the UpdateOrganizationUserDto interface.
 */
export function instanceOfUpdateOrganizationUserDto(value: object): value is UpdateOrganizationUserDto {
    return true;
}

export function UpdateOrganizationUserDtoFromJSON(json: any): UpdateOrganizationUserDto {
    return UpdateOrganizationUserDtoFromJSONTyped(json, false);
}

export function UpdateOrganizationUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}

export function UpdateOrganizationUserDtoToJSON(json: any): UpdateOrganizationUserDto {
    return UpdateOrganizationUserDtoToJSONTyped(json, false);
}

export function UpdateOrganizationUserDtoToJSONTyped(value?: UpdateOrganizationUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

